import { render, staticRenderFns } from "./ReturnsDialog.vue?vue&type=template&id=7fd4d1bf&scoped=true"
import script from "./ReturnsDialog.vue?vue&type=script&lang=ts"
export * from "./ReturnsDialog.vue?vue&type=script&lang=ts"
import style0 from "./ReturnsDialog.vue?vue&type=style&index=0&id=7fd4d1bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd4d1bf",
  null
  
)

export default component.exports